import React, { PureComponent } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink as RouterLink, withRouter, Route, Redirect } from "react-router-dom";
import _, { capitalize } from "lodash";
import { showMsgLogOut } from "../actions/notificationAction";
import { withStyles } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import {
  WithStyles,
  createStyles,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  Avatar,
  Menu,
  MenuItem,
  Popover,
  List,
  ListItem,
  Divider,
  CardMedia,
  Grid,
  ListItemText,
} from "@material-ui/core";
import {
  Notifications as NotificationsIcon,
  ArrowDropDown as DropDownIcon,
  ArrowDropUp as DropUpIcon,
} from "@material-ui/icons";
import { SearchField, MyPATLink, MyPATProfileBox } from "../../common";
import { actions } from "../../login";
const { userActionV2 } = actions;
import ACL from "../../acl/components/ACL";
import {
  getNotificationCount,
  getNotificationList,
  clearNotification,
} from "../actions/notificationAction";
import NotificationBody from "../types/NotificationBody";
import dateService from "../../common/services/dateService";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import PerfectScrollbar from "react-perfect-scrollbar";
import ACLService from "../../acl/services/aclService";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Autocomplete from "../../common/Autocomplete";
import { isEmpty, getPropertyValue, getUserType } from '../../../utils';
import { checkForNoRight, redirectToCourseRequest } from '../../course-Management/helpers/helpers';
import { MODULES, ADDITIONAL_FUNCTIONALITY, USER_TYPE, USER_RIGHTS } from '../../../constants/comman';
import { QUESTIONS_AVAILABLE_FOR_VALIDATION } from "../../mylibrary/constant/content";


const styles = (theme: Theme) =>
  createStyles({
    activeNav: {
      borderLeft: "3px solid rgb(29, 125, 234)",
      width: 80,
      position: "relative",
      padding: 8,
      height: 80,
      textDecoration: "none",
      "& >.blueIcon": {
        display: "block",
      },
      // "& >.greyIcon": {
      //   display: "none",
      // },
      "& p": {
        color: `rgb(29 125 234)`,
      },
      "&:hover": {
      "& img": {
        display: "none",
        }
      },
    },
    primaryNotificationColor: {
      color: "rgb(29, 125, 234)",
      animation: "zoomout 3s 400ms infinite ease-in-out",
      marginBottom: 20,
      "& svg": {
        fontSize: 30,
        transform: "rotate(-30deg)",
      },
      width: 64,
      height: 64,
    },
    defaultNotificationColor: {
      color: "#999999",
      marginBottom: 20,
      width: 64,
      height: 64,
      "& svg": {
        fontSize: 30,
        transform: "rotate(-30deg)",
      },
    },
    notActiveNav: {
      padding: 8,
      display: "inherit",
      verticalAlign: "middle",
      paddingLeft: "24px",
      width: 80,
      height: 80,
      "& >.blueIcon": {
        display: "none",
      },
      // "& >.greyIcon": {
      //   display: "block",
      // },
      "&:hover": {
      "& img": {
        display: "none",
        }
      }
    },
    hoverImg: {
      "&:hover": {
        backgroundRepeat: "no-repeat !important",
        backgroundPosition: "center !important",
        // borderLeft: "4px solid rgb(29, 125, 234)",
        paddingLeft: 30,
        width: 80,
        position: "relative",
        padding: '0px 8px',
        textDecoration: "none !important",
        // backgroundSize: "24px 24px !important",
        backgroundSize: '100%',
        '&::before':{
          content: '" "',
          width: 4,
          background: '#1D7DEA',
          borderRadius: '0px 2px 2px 0px',
          height: 54,
          position: 'absolute',
          left: 0,
          top: 0,
        },
        "& >.blueIcon": {
          display: "block",
        },
        // "& >.greyIcon": {
        //   display: "none",
        // },
        "& p": {
          color: `rgb(29 125 234)`,
        }
        } 
    },
    myLibrary: {
    "&:hover": {
    // backgroundImage: "url(/assets/svg/myLibraryNav.svg)",
    backgoundImage: 'none'
    }
    },
    contentRequest: {
      "&:hover": {
        background: "url(/assets/svg/myLibraryNav.svg)",
        }
    },
    userImg: {
      textDecoration: 'none',
      "&:hover": {
      // backgroundImage: "url(/assets/svg/userManagement/user-icon.svg)",
      backgoundImage: 'none',      
      }
      },
     goalImg: {
        "&:hover": {
        // backgroundImage: "url(/assets/svg/goalNav.svg)",
        backgoundImage: 'none'
        }
     },
     reportImg: {
      "&:hover": {
      // backgroundImage: "url(/assets/svg/blueReportNav.svg)",
      backgoundImage: 'none'
      }
      },
    diableListItem: {
      display: "none",
    },
    dividerColor: {
      backgroundColor: "rgb(29, 125, 234)",
    },
    cursorPointer: {
      cursor: "pointer",
    },
    appBarRoot: {
      backgroundColor: theme.palette.common.white,
      borderColor: theme.palette.grey[300],
      borderStyle: "solid",
      borderWidth: 0,
      position: "fixed",
      top: 0,
      left: 0,
      height: "100%",
      fontFamily: '"Nunito", sans-serif',
      width: 80,
      flexShrink: 0,
      padding: "10px 8px 16px",
    },
    toolbarRoot: {
      marginBottom: -3,
    },
    logo: {
      flex: "0 0 auto",
      marginRight: "50px !important",
    },
    logoContainer: {
      height: 56,
    },
    searchInputRoot: {
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
    },
    appBarContent: {
      flex: "1 1 auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      "> div &": {
        flex: "0 0 auto",
      },
    },
    navItem: {
      textAlign: "center",
      alignItems: "center",
      paddingTop: 20,
      height: 80,
      justifyContent: "center",
      display: "flex",
      margin: "4px -12px",
      "& :first-child": {
        textDecoration: "none",
      },
      "& >.blueIcon": {
        display: "none",
      },
      // "& >.greyIcon": {
      //   display: "block",
      // },
    },
    notificationDiv: {
      height: "268px",
      overflowY: "auto",
      "& .scrollbar-container > .ps__rail-y": {
        opacity: 0.8,
      },
    },
    profileDropdown: {
      padding: "5px 12px",
    },
    menuRoot: {
      paddingBottom: 0,
      background: "rgb(255, 255, 255)",
      border: "0.8px solid rgba(0, 0, 0, 0)",
      transition: "margin-left .5s ease-in-out",
      borderRadius: "0px 4px 4px 0px",
      boxShadow: "11px 2px 30px -13px rgba(0,0,0,0.65)",
    },
    menuPaper: {
      transform:
        "translateY(10px) scale(1, 1) translateZ(0px) translateX(7px) !important",
      overflow: "unset",
      transition: "margin-left .5s ease-in-out",
    },    
    menuItemRoot: {
      border: 0,
      borderStyle: "solid",
      borderBottomWidth: 1,
      borderColor: theme.palette.grey[300],
      height: "auto",
      minWidth: "180px",
      padding: 10,
      "&:focus": {
        outline: "none",
      },
      "&:last-child": {
        borderBottomWidth: 0,
      },
      "& a": {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingRight: theme.spacing.unit * 2,
        paddingLeft: theme.spacing.unit * 2,
        width: "100%",
        "&:hover": {
          textDecoration: "none",
        },
      },
      "& img, & p": {
        display: "inline-block",
        verticalAlign: "top",
      },
    },
    maxHeight2:{
      maxHeight: 200,
      borderBottom: "solid 0.5px #999",
    },
    menuHelpLogout: {
      display: "flex",
    },
    menuActionItems: {
      textAlign: "center",
      padding: "0 0 0 0",
    },

    notificationPaper: {
      width: 340,
      background: "rgb(255, 255, 255)",
      border: "0.8px solid rgba(0, 0, 0, 0)",
      marginLeft: 10,
      transition: "margin-left .5s ease-in-out !important",
      borderRadius: "0px 4px 4px 0px",
      boxShadow: "11px 2px 30px -13px rgba(0,0,0,0.65)",
    },
    notificationListRoot: {},
    notificationListItemRoot: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: theme.spacing.unit * 1.5,
      cursor: 'pointer'
    },
    noNotification: {
      paddingTop: "150px",
    },
    notificationUnreaded: {
      backgroundColor: fade(theme.palette.primary.main, 0.15),
    },
    notificationAvatar: {
      flex: "0 0 auto",
      marginRight: theme.spacing.unit * 1.5,
    },
    notificationMsg: {
      flex: "0 0 auto",
      width: `calc(100% - ${40 + theme.spacing.unit * 1.5}px)`,
      textTransform: 'none',
      "& .profileName": {
        color: '#333',
        
      },
    },
    capitalize: {
      textTransform: "capitalize",
    },

    navigationWrapper: {
      flex: "1 1 auto",
      margin: `0 ${theme.spacing.unit}px`,
    },
    navigationList: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      "& li": {
        flex: "0 0 auto",
        padding: 0,
        width: "auto",
        "& a": {
          display: "inline-block",
          padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit}px`,
          borderBottom: "3px solid transparent",
          textDecoration: "none",
          transition: "all 0.15s linear",
          "&:hover": {
            textDecoration: "none",
          },
          "&.active": {
            borderColor: theme.palette.primary.main,
            "& p": {
              color: theme.palette.primary.main,
            },
          },
          "& p": {
            color: theme.palette.common.black,
          },
        },
      },
    },
    notificationIcon: {
      "&:hover:after": {
        content: '""',
        position: "absolute",
        left: "50%",
        marginLeft: -5,
        bottom: -7,
        width: 0,
        height: 0,
        borderLeft: "5px solid rgba(0, 0, 0, 0)",
        borderRight: "5px solid rgba(0, 0, 0, 0)",
        borderBottom: "8px solid rgb(0, 0, 0)",
      },
    },
    profileName: {
      borderRadius: "50%",
      border: "solid 1px rgb(147, 97, 221)",
      padding: "2px 10px 2px 10px",
      background: "rgb(147, 97, 221)",
      color: "rgb(255, 255, 255)",
      fontSize: "1.5rem",
      cursor: "pointer",
      width: 40,
      height: 40,
    },
    verticleSpace: {
      height: "calc(100% - 0px)",
      display: 'none'
    },
    navTitle: {
      fontWeight: 600,
      fontSize: 12,
      lineHeight: "8px",
      textAlign: "center",
      color: "#999999",
      textDecoration: "none",
    },
    "@keyframes zoomout": {
      from: {
        backgroundColor: "#fff",
      },

      to: {
        backgroundColor: "rgba(65, 125, 234, 0.21)",
      },
    },
    // SideNavigation New
    sidebarAction:{
      background: '#FFFFFF',
      boxShadow: '-11px 0px 12px rgb(43 45 55 / 12%)',
      width: '84px',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 9,
      '& .badge': {
        position: 'absolute',
        top: 14
      },
      '& .sidebarFooter': {
        position: 'absolute',
        zIndex: 1,
        height: '34%',
        bottom: 0,
        width: '100%',
        '&>:first-child': {
          position: 'absolute',
          right: 0,
          bottom: 0,
          left: 0
        }
      },
      '& .menuLists': {
        position: 'absolute',
        height: '50%',
        overflowY: 'auto',
        overflowX: 'hidden',
        width: '100%'
      },
      "&:hover":{  
        width: 230,
        backgroundColor: '#fff',        
        boxShadow: '8px 0px 12px rgba(43, 45, 55, 0.12)',
        "& .dBlock":{
          display: 'block'
         },
        "& li":{
         "& .dBlock":{
          display: 'block'
         },    
         '& img':{
          filter: 'grayscale(1)',
          // opacity: 0.5,
          },     
        }
      },
      '&>:first-child':{
        width: '100%',   
        '&:nth-child(2)':{
          paddingLeft: 0,
        },     
      },
      '&>:nth-child(2)':{
        width: '100%',   
        '&:nth-child(2)':{
          paddingLeft: 0,
        },     
      },      
    },
    
    customNavigaion:{
      border: '0.5px solid #d3d2d2',
      transform:
      "translateY(10px) scale(1, 1) translateZ(0px) translateX(7px) !important",
      transition: "margin-left .5s ease-in-out",
      background: '#FFFFFF',
      filter:'drop-shadow(0px 5px 2px rgba(0, 0, 0, 0.09))',
      borderRadius: 4,
      position: 'absolute',
      bottom: '0px',
      left: 160,
      maxHeight: 250,
      '& img':{
        filter: 'inherit!important',
      },
      '&::before':{
        content: '" "',
        borderWidth: '8px 0px 8px 15px',
        borderStyle: 'solid',
        borderColor: 'transparent transparent transparent #fff',
        display: 'block',
        width: 0,
        height: 0,
        transform: 'rotate(180deg)',
        position: 'absolute',
        bottom: '20px',
        left: '-15px',
      }
    },
    helpSupportDropdown:{
      // top: '25px!important',
      left: '230px!important',
      padding: '3px 5px 0',
      // position: 'relative',
      minWidth: 200,
      '&::before':{
        bottom: '27px!important',
      }
    },
    customNavigaion1:{      
      transform: "translateY(10px) scale(1, 1) translateZ(0px) translateX(7px) !important",
      transition: "margin-left .5s ease-in-out",
      background: 'transparent',      
      borderRadius: 4,
      position: 'absolute',
      top: '-290px',
      left: 223,
      height: 350, 
      width: '361px',     
    },
    
    navigation1Container:{
      border: '0.5px solid #d3d2d2',
      transform:
      "translateY(10px) scale(1, 1) translateZ(0px) translateX(7px) !important",
      transition: "margin-left .5s ease-in-out",
      background: '#FFFFFF',
      filter:'drop-shadow(0px 5px 2px rgba(0, 0, 0, 0.09))',
      borderRadius: 4,
      position: 'absolute',
      top: '-11px',
      left: 12,
      maxHeight: 350,
      minHeight: 350,
      minWidth: 350,
      height: 350,
      '& img':{
        filter: 'inherit!important',
      },
      '&::before':{
        content: '" "',
        borderWidth: '8px 0px 8px 15px',
        borderStyle: 'solid',
        borderColor: 'transparent transparent transparent #fff',
        display: 'block',
        width: 0,
        height: 0,
        transform: 'rotate(180deg)',
        position: 'absolute',
        bottom: '20px',
        left: '-15px',
      }
    },




    NavLinkText:{
      fontSize: 16,
      lineHeight: '45px',
      height: 68,
      fontWeight: 'bold',
      marginLeft: 16,
      textDecoration: 'none',
      color: '#999',
      marginTop: 5,
      display: 'none',
      cursor: 'pointer'
    },
    listItems:{
      paddingLeft: 0,
      paddingRight: 0,
      // width: 80,
      lineHeight: 54,
      height: 54,    
      '& img':{
        filter: 'grayscale(1)',
        // opacity: 0.5,
      },
      "&>:hover":{
        background: 'linear-gradient(-270deg, #1D7DEA -1858.04%, rgba(29, 125, 234, 0) 121.18%)',
        "&:nth-of-type(1)":{
          "& .dBlock":{
            color: '#1d7dea',
          }
        },
        '& img':{
          filter: 'initial!important',
          opacity: 1,
        },
      }  
    },
    notificationIcon1:{
      filter: 'initial!important',
      verticalAlign: 'middle',
      height: '100%'
    },
    pdL24:{
      paddingLeft: 24,
    },
    
    logoLg: {
      flex: "0 0 auto",
      marginLeft: 16,
      height: 50,
      marginTop:10,
      display: 'none'
    },
    logosm: {
      flex: "0 0 auto",
      marginTop: 28,
      height: 68,
    },
    logoContainerNew:{
      textAlign: 'center',
      marginTop: 12,
      marginBottom: 10,
      '&>a':{
        display: 'flex',
        justifyContent: 'flex-start',
        margin: '0px 15px 0px 10px'
      }
    },
    activeNavOpen: {
      background: 'linear-gradient(-270deg, #1D7DEA -1858.04%, rgba(29, 125, 234, 0) 121.18%)',
      // transform: 'matrix(-1, 0, 0, 1, 0, 0)',
      width: '100%',
      position: "relative",
      padding: '0px 8px',
      lineHeight: 54,
      height: 54,
      textDecoration: "none",
      '&::before':{
        content: '" "',
        width: 4,
        background: '#1D7DEA',
        borderRadius: '0px 2px 2px 0px',
        height: 54,
        position: 'absolute',
        left: 0,
        top: 0,
      },
      "& >.blueIcon": {
        display: "block",
      },
      "& .dBlock":{
        color: '#1d7dea',
      },
      "& p": {
        color: `rgb(29 125 234)`,
      },
      '& img':{
        filter: 'initial!important',
        opacity: 1,
      },
      "&:hover": {
        width: '100%',
      },
    },
    notActiveNavClose: {
      padding: '0px 8px',
      display: "inherit",
      verticalAlign: "middle",
      paddingLeft: 30,
      width: '100%',
      height: 54,
      textDecoration: 'none',
      "& >.blueIcon": {
        display: "none",
      },
      // "& >.greyIcon": {
      //   display: "block",
      // },
      "&:hover": {
        width: '100%',
      // "& img": {
      //   display: "none",
      //   }
      }
    },
    logedInUser:{
      borderTop: '0.5px solid #B8B4B4',
      width: '100%',
      display: 'inherit',
      padding: '0px 6px'
    },
    userFirstName:{
      width: 36,
      height: 36,
      borderRadius: '50%',
      backgroundColor: '#9361DD',
      padding: '4px 11px',
      marginRight: 12,
      marginTop: 18,
      '&>span':{
        fontSize: 20,
        color: '#fff',
      },
    },
    LocationInfo:{
      width: 36,
      height: 36,
      borderRadius: '50%',
      backgroundColor: '#9361DD',
      // padding: '4px 11px',
      marginRight: 12,
      verticalAlign: 'middle!important',
      '&>span':{
        fontSize: 20,
        color: '#fff',
        height: 30,
        lineHeight: '36px',
        padding: 12,
      },
    },
    commonLinkTxt:{
      color: '#333',
      fontSize: 14,  
      textDecoration: 'none',
      '&>a':{
        textDecoration: 'none'
      }
    },
    commonLink:{
      padding: 10,
      '& img':{
        verticalAlign: 'text-bottom',
        marginRight: 12,
      }
    },
    userStatus:{
      marginTop: 18,
      display: 'none',
      textTransform: 'capitalize',
      cursor: 'pointer',
      position: 'relative'
    },
    userNameInfo:{
      fontSize: 14,
      color: '#666',
    },
    borderBot:{
      "border-bottom":"solid 0.5px #999999",
    },
    userType:{
      fontSize: 12,
      color: '#999',
      display: 'block',
    },
    NotificationImg:{
      position: 'relative'
    },
    NotificationNum:{
      position: 'absolute',
      top: 5,
      right: 5,
      borderRadius: '50%',
      backgroundColor: 'F23C3C',
      border: '1px solid #fff',
      fontSize: 9,
      fontWeight: 600,
    },
    vAsub:{
      verticalAlign: 'sub'
    },
    posRel:{
      position: 'relative'
    },
    // Location
    RightArrowD:{
      position: 'absolute',
      right: '12px',
      top: '2px'
    },
    locatorMain:{
      display: 'none', //@Frotnend Dev: Todo uncomment it whenever need to start
      position: 'relative',
      borderTop: '0.5px solid #B8B4B4',
      borderBottom: '0.5px solid #B8B4B4',
      marginBottom: 25,
      height: 50,
      marginTop: 15,
      '&>:first-child':{
        '& span:nth-child(2)':{
          height: '39px',
          lineHeight: '48px',
          marginTop: 0
        },
        '& RightArrowD':{
          top: 14,
        },
        '&:hover':{
          '& span:nth-child(2)':{
            height: '49px',
            lineHeight: '48px',
            '&: span:first-child':{
              top: 14,
            }
          } ,
          '&::before':{
            height: '49px',
          },           
        }
      },
      '&:hover':{
        '&>:first-child':{
          '&::before':{
            height: '49px',
          },  
          '& span:nth-child(2)':{
              lineHeight: '48px',
              height: '39px',
          }    
        },
      }
    },
    locatorDropdown:{
      top: '-59px!important',
      left: '225px!important',
      padding: '3px 5px 0',
      position: 'relative',
      minWidth: 200,
      '&::before':{
        top: '15px!important',
      }
    },
    borderNone:{
      border: 'none'
    },
    dflex:{
      display: 'flex!important',
      paddingTop: 0,
      paddingBottom: 0,
      height: '46px',
    },
    autoCompleteBox: {
      position: 'relative',     
      '& .options': {
        position: 'absolute',
        background: 'rgb(255 255 255)',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
        borderRadius: 8,
        overflowY: 'auto',
        overflowX: 'hidden',
        maxHeight: 130,
        padding: 0,
        width: '25rem',
        marginTop: 0,
        '&>li': {
          color: '#333',
          fontSize: 16,
          lineHeight: '20px',
          padding: '7px 12px',
          '&:hover': {
            background: 'rgb(247 247 247)'
          }
        }
      },
      '& .search-input-field': {
        marginLeft: 40,
        '& input': {
          padding: '9px 4px',
          width: 140,
          border: 0,
          fontSize: 14,
          color: '#999',
          '&:active, &:hover, &:focus':{
            outline: 'none',
          }
        }
      },
      '& .option-active': {
        background: '#F7F7F7',
        fontSize: 16,
        color: '#333'
      },
      '& .search-btn': {
        position: 'absolute',
        left: 0,
        top: 4,
        bottom: 0,
        display: 'block',
        padding: '0px 12px',
        background: 'rgb(255 255 255)',
        border: 0,
        '&>img':{
          verticalAlign: 'text-bottom'
        }
      }
    },
    fontSize_SM: {
      fontSize: 16,
    },
    grey: {
      color: '#666666'
    },
    helpSupport:{
      width: '100%',
      display: 'flex !important',
      height: 'initial',
      alignItems: 'center',
      '& span':{
        height: 'initial',
      }
    },
    marTopBot15:{
      marginTop: '15px',
      marginBottom: '15px',
    },
    menuBackdrop:{
      position: 'absolute',
      width: '15px',
      left: '160px',
      height: '180px',
      bottom: '0px',
      opacity: 0,
    },
    noCpitalize:{
      'text-transform':'initial !important',
    },
  });

//@ts-ignore
interface HeaderProps extends WithStyles<typeof styles> {
  classes: any;
  userData: any;
  logout: Function;
  showMsgLogOut: Function;
  notificationList: NotificationBody[];
  notificationCount: number;
  clearNotification: Function;
  getNotificationCount: Function;
  getNotificationList: (limit: number, skip: number) => void;
  switchRole: (index: number) => void;
  history: any;
}

interface HeaderStates {
  searchValue: string;
  notificationEl: any;
  isNotificationsOpen: boolean;
  islocatorMenuOpen:boolean;
  profileEl: any;
  isProfileMenuOpen: boolean;
  isHelpMenuOpen: boolean;
  pageSkip: number;
  limit: number;
  reinit: boolean;
  showTooltip: boolean;
  navName: string;
}

class Header extends PureComponent<HeaderProps, HeaderStates> {
  listElement: any;
  navActive: boolean;
  navNotActive: boolean;
  selectedNav: string;
  currentNav: string;
  constructor(props: HeaderProps) {
    super(props);
    this.navActive = false;
    this.navNotActive = false;
    this.selectedNav = "";
    this.state = {
      searchValue: "",
      notificationEl: null,
      isNotificationsOpen: false,
      profileEl: null,
      isProfileMenuOpen: false,
      isHelpMenuOpen: false,
      islocatorMenuOpen: false,
      pageSkip: 0,
      limit: 6,
      reinit: false,
      showTooltip: false,
      navName: "",
    };
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleProfileMenuOpen = this.handleProfileMenuOpen.bind(this);
    this.locatorMenuOpen = this.locatorMenuOpen.bind(this);
    this.handleProfileMenuClose = this.handleProfileMenuClose.bind(this);
    this.handleRoleSwitch = this.handleRoleSwitch.bind(this);
    this.listenToScroll = this.listenToScroll.bind(this);
    this.handleRouterClick = this.handleRouterClick.bind(this);
    this.currentNav = window.location.pathname;
    this.handleHelpMenuOpen = this.handleHelpMenuOpen.bind(this);
    this.handleHelpMenuClose = this.handleHelpMenuClose.bind(this);

  }
  componentDidMount() {
    setTimeout(() => this.setState({ reinit: true }), 5000);
  }
  componentDidUpdate() {
    this.props.getNotificationCount();
  }
  handleSearchChange = (event: any) => {
    this.setState({
      ...this.state,
      searchValue: event.target.value,
    });
  };
  handleNotificationOpen = (event: any) => {
    const { limit, pageSkip } = this.state;
    this.props.clearNotification();
    this.props.getNotificationList(limit, 0);
    this.setState({
      ...this.state,
      // isNotificationsOpen: true,
      isNotificationsOpen: !this.state.isNotificationsOpen,
      notificationEl: event.currentTarget,
    });
  };
  
  handleNotificationClose = (event: any) => {
    this.setState({
      ...this.state,
      isNotificationsOpen: false,
      pageSkip: 0,
      notificationEl: null,
    });
  };
  closePopups(e: any) {
    this.setState({
      isNotificationsOpen: false,
      pageSkip: 0,
      notificationEl: null,
      isProfileMenuOpen: false,
      isHelpMenuOpen: false,
      profileEl: null,
    });
  }
  handleProfileMenuOpen = (event: any) => {
    this.setState({
      ...this.state,
      isProfileMenuOpen: !this.state.isProfileMenuOpen,
      profileEl: event.currentTarget,
    });
  };

  handleProfileMenuClose = (event: any) => {
    this.setState({
      ...this.state,
      isProfileMenuOpen: false,
      profileEl: null,
    });
  };
//Help support open
//Adding this block for now will remove it later//
  handleHelpMenuOpen = (event: any) => {
    this.setState({
      ...this.state,
      isHelpMenuOpen: !this.state.isHelpMenuOpen,
      profileEl: event.currentTarget,
      
    });
  };

  handleHelpMenuClose = (event: any) => {
    this.setState({
      ...this.state,
      isHelpMenuOpen: false,
      profileEl: null,
    });
  };
// Locator
locatorMenuOpen = (event: any) => {
  this.setState({
    ...this.state,
    islocatorMenuOpen: !this.state.islocatorMenuOpen,
    profileEl: event.currentTarget,
  });
};

locatorMenuClose = (event: any) => {
  this.setState({
    ...this.state,
    islocatorMenuOpen: false,
    profileEl: null,
  });
};
// End
  handleRoleSwitch = (i: number, e: any) => {
    this.props.switchRole(i);
     this.setState({ isProfileMenuOpen: false });
  };

  listenToScroll(e: any) {
    let { pageSkip, limit } = this.state;
    const { getNotificationList, notificationList } = this.props;
    if (
      limit * (1 + pageSkip) == notificationList.length &&
      this.listElement.scrollHeight - this.listElement.scrollTop < 360
    ) {
      pageSkip = pageSkip + 1;
      getNotificationList(limit, pageSkip);
      this.setState({ pageSkip });
    }
  }

  handleHover() {
    this.setState({
      showTooltip: !this.state.showTooltip,
    });
  }

  // handleRouterLink(match: any, location?: any) {
  // 	this.selectedNav = location && location.path;
  // 	if (match && match.isExact == true) {
  // 		this.navActive = !this.navActive;
  // 		return this.navActive;
  // 	}
  // 	else {
  // 		this.navActive = !this.navActive;
  // 		return this.navActive;
  // 	}
  // }

  handleRouterClick(routerName: string) {
    this.setState({
      navName: routerName,
    });
  }

  handleNotificationClick = (notification: any) => {
    const contentId = getPropertyValue(notification, 'payload.contentId');
    const contentTypeCode = getPropertyValue(notification, 'payload.contentTypeCode');
    if (notification.notificationType === QUESTIONS_AVAILABLE_FOR_VALIDATION) {
      localStorage.setItem('actionType', 'validationRequest');
      this.props.history.push('/mylibrary');
      return;
    }
    if ((contentId && contentTypeCode)) {
      this.props.history.push(`/content/preview/${contentId}${contentTypeCode}`);
      return;
    }
    const requestDetails = getPropertyValue(notification, 'payload');
    if (isEmpty(requestDetails) || checkForNoRight(MODULES.COURSE)) {
      return;
    }
    const redirectionUrl = redirectToCourseRequest({ _id: requestDetails.packageChangeRequestId, ...requestDetails });
    this.props.history.push(redirectionUrl);
  }

  render() {
    const {
      classes,
      userData,
      logout,
      showMsgLogOut,
      notificationCount,
      notificationList,
      
    } = this.props;
    let user =ACLService.getUserDetailsFromStorage().authenticatedUser;
    if (!user) {
      return (<Redirect to='/login' />)
    }
    const aclData = ACLService.getUserDetailsFromStorage().authenticatedUser;
    let userName: string = aclData.fullName || aclData.firstName;
    const {
      searchValue,
      isNotificationsOpen,
      notificationEl,
      isProfileMenuOpen,
      isHelpMenuOpen,
      islocatorMenuOpen,
      profileEl,
      showTooltip,
      navName,
    } = this.state;
    const checkModuleAccess = (role: string) => {
      let accessArray = user && user.clientId && user.clientId.access;
      let permissionArray = role !== 'content' ? !ACLService.checkModulePermission(role, "none") : true;
      let access = accessArray &&
      accessArray.filter(function(ele: any) {
        return ele.name === role;
      }) &&
      accessArray.filter(function(ele: any) {
        return ele.name === role;
      })[0] &&
      accessArray.filter(function(ele: any) {
        return ele.name === role;
      })[0].isAllowed
      return ( access && permissionArray);
    };

    const fullUserName = userName && userName.split('')[0].toUpperCase().concat(userName.substring(1))
    const studentUser = getUserType(USER_TYPE.STUDENT);

    return (
      <AppBar
        classes={{ root: classes.appBarRoot }}
        position="fixed"
        color="default"
        elevation={2}
      >
        {/* Sidebar Revamp */}
        <Grid container justify="space-between"
          onMouseLeave={e => this.closePopups(e)}
          direction="column" className={[classes.sidebarAction, "largeContaier"].join(' ')}>
          <Grid item>
            <Grid className={classes.logoContainerNew}>
              <a href="/mylibrary">
              <img
                  className={classes.logoSm}
                  src="/assets/svg/mypatAuthorLogoSM.svg"
                  alt="Glorifire logo"
                />
                <img
                  className={[classes.logoLg, 'dBlock'].join(' ')}
                  src="/assets/svg/mypatAuthorLogo.svg"
                  alt="Glorifire logo"
                />
              </a>
            </Grid>
            {/* Location */}
            {/* <ClickAwayListener
              onClickAway={this.locatorMenuClose}>  */}
              { ACLService.getUserDetailsFromStorage() && ACLService.getUserDetailsFromStorage().authenticatedUser && ACLService.getUserDetailsFromStorage().authenticatedUser.isAdmin &&
                  <Grid onClick={this.locatorMenuOpen.bind(this)} className={classes.locatorMain}>
                  <Typography
                    className={[classes.notActiveNavClose, classes.hoverImg, classes.dflex, classes.myLibrary].join(" ")}
                    
                  >
                    <img
                        src="/assets/svg/locator.svg"
                        alt="Goal"
                        width="20"
                      />
                    <span className={[classes.NavLinkText, 'dBlock'].join(' ')}>Hawz Khas <span className={classes.RightArrowD}><img src="/assets/svg/myLibrary/pagination/arrow-right.svg"/></span></span>
                  </Typography> 
                  {/* <ListItemText primary="Library" /> */}
                  { 
                    islocatorMenuOpen &&
                  <Grid className={[classes.customNavigaion, classes.locatorDropdown].join(' ')}>   
                    <Grid className={classes.autoCompleteBox}>
                      <div className="search">
                        <div className="chipInput">
                        <div className="search-input-field">
                          <input
                            type="text"
                            className="search-box"
                            // onChange={onChange}
                            // onClick={() => this.handleOnClick()}
                            // onBlur={() => this.handleOnBlur()}
                            // value={1}
                            placeholder="Search Client"
                          />            
                        </div>
                        </div>
                        <span className="search-btn">
                          <img
                            src="/assets/svg/userManagement/search-icon.svg"
                            alt="search"
                          />
                        </span>
                      </div>
                      {/* {optionList} */}
                    </Grid>   
                    <PerfectScrollbar> 
                      <Grid className={classes.maxHeight2}>            
                        <Grid className={[classes.menuItemRoot, classes.borderNone].join(' ') }>                        
                            <span className={classes.userNameInfo}>Hawz Khas</span>
                            {/* @Frontend make it dynamic */}
                        </Grid>

                        <Grid className={[classes.menuItemRoot, classes.borderNone].join(' ') }>
                            <span className={classes.userNameInfo}>Hawz Khas</span>
                            {/* @Frontend make it dynamic */}
                        </Grid>
                        <Grid className={[classes.menuItemRoot, classes.borderNone].join(' ') }>                        
                            <span className={classes.userNameInfo}>Hawz Khas</span>
                            {/* @Frontend make it dynamic */}
                        </Grid>

                        <Grid className={[classes.menuItemRoot, classes.borderNone].join(' ') }>
                            <span className={classes.userNameInfo}>Hawz Khas</span>
                            {/* @Frontend make it dynamic */}
                        </Grid>
                      </Grid>
                    </PerfectScrollbar>
                  </Grid>
                }
              </Grid> }
              {/* </ClickAwayListener> */}
              {/* End Location */}
              <Grid className="menuLists">
              <PerfectScrollbar>
              <List>                 
              { checkModuleAccess('goal') ?      
              <ListItem classes={{root: classes.listItems}}>
                <RouterLink
                  to="/goal-management"
                  activeClassName={classes.activeNavOpen}
                  className={[classes.notActiveNavClose,classes.hoverImg, classes.myLibrary].join(" ")}
                >
                  <Route
                    path={`/goal-management`}
                    children={({ match }) =>  {
                      return (
                        <>
                          <img
                              src="/assets/svg/goalNav1.svg"
                              alt="Goal"
                              width="20"
                            />                          
                        </>
                      );
                    }}
                  />
                  <span className={[classes.NavLinkText, 'dBlock'].join(' ')}>Goal</span>
                </RouterLink> 
                {/* <ListItemText primary="Library" /> */}
              </ListItem> : null}             
              <ListItem classes={{root: classes.listItems}}>
                <RouterLink
                  exact
                  to={`/mylibrary`}
                  isActive={isActiveMyLibrary}
                  activeClassName={classes.activeNavOpen}
                  className={[classes.notActiveNavClose,classes.hoverImg, classes.myLibrary].join(" ")}
                >
                  <Route
                    path={`/mylibrary`}
                    children={({ match, location }) => {
                      return (
                        <>
                          <img
                              src="/assets/svg/myLibraryNav.svg"
                              alt="Report"
                              width="20"
                            />                          
                        </>
                      );
                    }}
                  />
                  <span className={[classes.NavLinkText, 'dBlock'].join(' ')}>Library</span>
                </RouterLink>
              </ListItem>
              { checkModuleAccess('content') && !getUserType(USER_TYPE.STUDENT) ? 
              <ListItem classes={{root: classes.listItems}}>
                <RouterLink
                  to={`/contentRequest`}
                  activeClassName={classes.activeNavOpen}
                  className={[classes.notActiveNavClose,classes.hoverImg, classes.myLibrary].join(" ")}
                >
                  <Route
                    path={`/contentRequest`}
                    children={({ match, location }) => {
                      return (
                        <>
                          <img
                              src="/assets/svg/contentRequest/content_request.svg"
                              alt="request"
                              width="20"
                            />                          
                        </>
                      );
                    }}
                  />
                  <span className={[classes.NavLinkText, 'dBlock'].join(' ')}>Content Request</span>
                </RouterLink>
              </ListItem> : null }
              {/* { checkModuleAccess('course') ? 
              <ListItem classes={{root: classes.listItems}}>
                <RouterLink
                  to={`/course`}
                  activeClassName={classes.activeNavOpen}
                  className={[classes.notActiveNavClose,classes.hoverImg, classes.myLibrary].join(" ")}
                >
                  <Route
                    path={`/course`}
                    children={({ match, location }) => {
                      return (
                        <>
                          <img
                              src="/assets/svg/contentRequest/content_request.svg"
                              alt="request"
                              width="20"
                            />                          
                        </>
                      );
                    }}
                  />
                  <span className={[classes.NavLinkText, 'dBlock'].join(' ')}>Courses</span>
                </RouterLink>
              </ListItem> : null } */}
              {(ACLService.checkModulePermission(MODULES.EDP_QUESTION_CREATE_REPORT, USER_RIGHTS.DOWNLOAD) || ACLService.checkModulePermission(MODULES.EDP_QUESTION_ISSUE_REPORT, USER_RIGHTS.DOWNLOAD)) ? (
              <ListItem classes={{root: classes.listItems}}>
                    <RouterLink
                      exact
                      to="/reports"
                      activeClassName={classes.activeNavOpen}
                      className={[classes.notActiveNavClose,classes.hoverImg, classes.reportImg].join(" ")}
                    >
                      <Route
                        path="/reports"
                        children={({ match }) => (
                          <>
                            <img
                              src="/assets/svg/blueReportNav.svg"
                              alt="Report"
                              width="20"
                            />
                          </>
                        )}
                      />
                      <span className={[classes.NavLinkText, 'dBlock'].join(' ')}>Report</span>
                    </RouterLink>
              </ListItem>
                 ) : null}
              {ACLService.isSuperAdmin() ? (
              <ListItem classes={{root: classes.listItems}}>
                  <RouterLink
                    to="/userManagement"
                    activeClassName={classes.activeNavOpen}
                    className={[classes.notActiveNavClose,classes.hoverImg, classes.userImg].join(" ")}
                  >
                  <Route
                      path="/userManagement"
                      children={({ match }) => (
                        <>
                          <img
                            src="/assets/svg/userManagement/user-icon.svg"
                            alt="User"
                            width="20"
                          />

                        </>
                      )}
                    />
                    <span className={[classes.NavLinkText, 'dBlock'].join(' ')}>User</span>
                  </RouterLink>
              </ListItem>
              ) : null}
              {checkModuleAccess("course") ? (
              <ListItem classes={{root: classes.listItems}}>
                  <RouterLink
                    to="/course-Management"
                    activeClassName={classes.activeNavOpen}
                    className={[classes.notActiveNavClose,classes.hoverImg, classes.userImg].join(" ")}
                  >
                  <Route
                      path="/course-Management"
                      children={({ match }) => (
                        <>
                          <img
                            src="/assets/svg/coursesIcon.svg"
                            alt="User"
                            width="20"
                          />

                        </>
                      )}
                    />
                    <span className={[classes.NavLinkText, 'dBlock'].join(' ')}>Course</span>
                  </RouterLink>
              </ListItem>
              ) : null}
              <ListItem>

              </ListItem>
              </List>
              </PerfectScrollbar>
            </Grid>
          </Grid>
          <Grid item>
            <Grid className="sidebarFooter">
            <List>                         
              <ListItem classes={{root: classes.listItems}} 
              // onMouseOver={this.handleHover.bind(this)}
              // onMouseOut={this.handleHover.bind(this)}
              >                      
              <ClickAwayListener
              onClickAway={this.handleNotificationClose}> 
                  <Typography className={[classes.notActiveNavClose,classes.hoverImg, classes.myLibrary, classes.posRel].join(" ")} onClick={this.handleNotificationOpen.bind(this)} onBlur={this.handleNotificationOpen.bind(this)}>
                    <span>
                    <img
                      className={classes.notificationIcon1}
                      src="/assets/svg/notificationIcon.svg"
                      width="20"
                      alt="Notifications"
                    />
                    <Badge badgeContent={notificationCount} className="badge" color="secondary">
                   </Badge>
                    </span>
                    
                    <span className={[classes.NavLinkText, 'dBlock'].join(' ')}>Notifications</span>
                    {/* Notification Dropdown */}
                    {
                    isNotificationsOpen &&
                    <div
                      className={classes.customNavigaion1}
                      onScroll={(e: any) => this.listenToScroll(e)}
                      ref={(el: any) => {
                        this.listElement = el;
                      }}
                    >
                      <div className={classes.navigation1Container}>
                        <PerfectScrollbar>
                          <List
                            disablePadding
                            classes={{ root: classes.notificationListRoot }}
                          >
                            {_.isEmpty(notificationList) ? (
                              <Typography
                                className={classes.noNotification}
                                variant="subtitle1"
                                color="textSecondary"
                                align="center"
                              >
                                <strong>No Notification</strong>
                              </Typography>
                            ) : (
                              _.map(
                                notificationList,
                                (notification: any, i: number) => {
                                  if (notification.aclMetaData.createdBy.id == null) {
                                    notification.aclMetaData.createdBy.id = {};

                                    notification.aclMetaData.createdBy.id[
                                      "profileImage"
                                    ] = "/assets/img/profile-default.png";

                                    notification.aclMetaData.createdBy.id["firstName"] =
                                      '';
                                    notification.aclMetaData.createdBy.id["lastName"] =
                                      " ";
                                  } else if (
                                    notification.aclMetaData.createdBy.id.lastName ==
                                    undefined
                                  ) {
                                    notification.aclMetaData.createdBy.id["lastName"] =
                                      " ";
                                  }

                                  if (notification.message) {
                                    let notify_msg = notification.message.split(" ");
                                    if (notify_msg.includes("undefined")) {
                                      notification.message = notification.message.replace(
                                        "undefined",
                                        " "
                                      );
                                    }
                                  }
                                  return (
                                    <div key={`notification-${i}`} className={classes.cursorPointer}>
                                      <ListItem
                                        disableGutters
                                        className={
                                          notification.isRead
                                            ? ""
                                            : classes.notificationUnreaded
                                        }
                                        classes={{
                                          root: classes.notificationListItemRoot,
                                        }}
                                        onClick={() => this.handleNotificationClick(notification)}
                                      >
                                        {notification.aclMetaData.createdBy.id
                                          .profileImage ? (
                                          <Avatar
                                            src={
                                              notification.aclMetaData.createdBy.id
                                                .profileImage
                                            }
                                            alt={
                                              notification.aclMetaData.createdBy.id
                                                .firstName
                                            }
                                            classes={{
                                              root: classes.notificationAvatar,
                                            }}
                                          />
                                        ) : (
                                          <span className={classes.profileName}>
                                            {userName &&
                                              userName.slice(0, 1).toUpperCase()}
                                          </span>
                                        )}
                                        <div className={classes.notificationMsg}>
                                          <Typography variant="body2">
                                            {(notification.sourceType !== 'content-request' || notification.notificationType === 'content-request-created') && !(notification.notificationType || '').includes(ADDITIONAL_FUNCTIONALITY.CONTENT_VALIDATION) && (
                                              <strong className="profileName capitalize">{`${
                                                notification.payload && notification.payload.name ? notification.payload.name : 
                                                (
                                                  notification.aclMetaData.createdBy.id
                                                    .fullName
                                                    ? notification.aclMetaData.createdBy.id
                                                        .fullName
                                                    : notification.aclMetaData.createdBy.id
                                                        .firstName +
                                                      notification.aclMetaData.createdBy.id
                                                        .lastName
                                                )
                                              } `}</strong>
                                            )}
                                            <span style={{ fontWeight: "normal", color: '#333' }}>
                                              {notification.message}
                                            </span>
                                          </Typography>
                                          <Typography variant="caption" className="profileName capitalize">
                                            {`${dateService.getTimeAgo(
                                              notification.createdAt
                                            )} ago`}
                                          </Typography>
                                        </div>
                                      </ListItem>
                                      <Divider variant="inset" component="li" />
                                    </div>
                                  );
                                }
                              )
                            )}
                          </List>
                        </PerfectScrollbar>
                      </div>  
                    </div>    
                  }      
                  </Typography>  
                  </ClickAwayListener>                    
              </ListItem>
              
              {!studentUser && <ListItem classes={{root: classes.listItems}}>
              <ClickAwayListener
              onClickAway={this.handleHelpMenuClose}> 
                 <Typography className={[classes.notActiveNavClose,classes.hoverImg, classes.myLibrary, classes.posRel].join(" ")} onClick={this.handleHelpMenuOpen.bind(this)} onBlur={this.handleHelpMenuOpen.bind(this)}>
                    <span className={classes.helpSupport}>
                   <img
                    className="greyIcon"
                    src="/assets/svg/helpSupport.svg"
                    width="20"
                    alt="helpSupport"
                  />
                  <span className={[classes.NavLinkText, 'dBlock'].join(' ')}>Help &amp; Support</span>
                        {/* Dropdown */}    
                        {
                          isHelpMenuOpen &&
                        <Grid className={[classes.customNavigaion, classes.helpSupportDropdown].join(' ')}>
                            {/* <Typography className={classes.commonLink}>
                                <a
                                  href="https://authorhelp.glorifire.com" target="_blank"
                                  className={classes.userImg}
                                >
                                  <img src="/assets/svg/cmsManual.svg"/>
                                  <span className={classes.commonLinkTxt}>CMS Manual</span>
                                </a>
                              </Typography> */}
                            <Typography className={classes.commonLink}>
                                <a href="https://www.notion.so/myPAT-Authors-CMS-User-Manual-80a1c948c3264d1d80f19e8c9e7d42b1" target="_blank"
                                  className={classes.userImg}
                                >
                                  <img src="/assets/svg/editorManual.svg"/>
                                  <span className={classes.commonLinkTxt}>Editor Manual</span>
                                </a>
                              </Typography>  
                              
                              <Typography className={classes.commonLink}>
                                <a
                                  href="https://www.notion.so/Maths-Editor-Shortcut-keys-e71d25e1080c4d798933ae773bdbdb24" target="_blank"
                                  className={classes.userImg}
                                >
                                  <img src="/assets/svg/mathSortKey.svg"/>
                                  <span className={classes.commonLinkTxt}>Maths Short Key list</span>
                                </a>   
                              </Typography>      
                        </Grid>
                        }
                      {/* End */}                   
                    </span>                    
                 </Typography>    
                </ClickAwayListener>             
              </ListItem>}
              <ListItem>
              <ClickAwayListener
              onClickAway={this.handleProfileMenuClose}> 
                 <Grid className={classes.logedInUser} onClick={this.handleProfileMenuOpen.bind(this)} onBlur={this.handleProfileMenuOpen.bind(this)}>
                  <Typography className={[classes.userFirstName, classes.profileDropdown].join(' ')}>
                    <span>{userName && userName.slice(0, 1).toUpperCase()}</span>
                  </Typography>
                    <span className={[classes.userStatus, 'dBlock'].join(' ')}>
                          <span className={classes.userNameInfo}>{userName} <img  className={classes.vAsub} src="assets/svg/myLibrary/pagination/arrow-right.svg"/></span>
                          <span className={classes.userType}>
                            {
                              !_.isUndefined(user.roles[0].roleId) &&
                              user.roles[0].roleId.role
                            } 
                        </span>   
                        {/* Dropdown */}    
                        {
                          isProfileMenuOpen &&<>
                          <div className={classes.menuBackdrop}></div>
                        <Grid className={classes.customNavigaion}>      
                          <PerfectScrollbar>                    
                          <Grid className={classes.maxHeight2}>
                            <Grid className={classes.menuItemRoot }>
                                <Typography className={classes.LocationInfo}>
                                  <span>{userName && userName.slice(0, 1).toUpperCase()}</span>                    
                                </Typography>
                                <span className={classes.userNameInfo}>{fullUserName}</span>
                                {/* @Frontend make it dynamic */}
                            </Grid>
                          </Grid>
                          </PerfectScrollbar>
                          <Grid>
                              <Typography className={classes.commonLink}>
                              <MyPATLink
                                 to="/terms-of-use"
                                  variant="body1"
                                  displayProp="inline-block"
                                >
                                  <img src="/assets/svg/terms_use.svg" alt="Terms" />
                                  <span  className={[classes.commonLinkTxt, classes.noCpitalize].join(' ')}>Terms of Use</span>
                                </MyPATLink>
                                <MyPATLink className={classes.marTopBot15}
                                 to="/privacy-policy"
                                  variant="body1"
                                  displayProp="inline-block"
                                >
                                  <img src="/assets/svg/privacy_policy.svg" alt="Privacy" />
                                  <span className={classes.commonLinkTxt}>Privacy Policy</span>
                                </MyPATLink>
                              {!studentUser && <div
                                  onClick={() => {
                                    logout();
                                  }}
                                >
                                  <img src="/assets/svg/logout_outline.svg"/>
                                  <span className={classes.commonLinkTxt}>Logout</span>
                                </div>}
                               
                              </Typography>
                          </Grid>                          
                        </Grid>
                        </>
                        }
                      {/* End */}                   
                    </span>                    
                 </Grid>    
                </ClickAwayListener>             
              </ListItem>
              </List>
            </Grid>
          </Grid>
        </Grid>
        {/* End */}

        {/* This is old code of Navigaiton */}
        <Grid
          container
          direction={"column"}
          alignItems="center"
          justify="space-between"
          className={classes.verticleSpace}
        >
          <Grid item alignItems="center">
            <Grid className={classes.logoContainer}>
              <a href="/">
                <img
                  className={classes.logo}
                  width="100%"
                  height="45"
                  src="/assets/svg/penLogo.svg"
                  alt="my pat logo"
                />
              </a>
            </Grid>
            <Divider classes={{ root: classes.dividerColor }} />
            <Grid className={classes.diableListItem}>
              {/* classes.activeNav we can for active and remove disableListItem */}
              <RouterLink
                exact
                to="/dashboard"
                activeClassName={classes.activeNav}
              >
                <img
                  className="greyIcon"
                  src="/assets/svg/goalGreyNav.svg"
                  width="33"
                  alt="dash"
                />
                <img
                  className="blueIcon"
                  src="/assets/svg/goalNav.svg"
                  width="33"
                  alt="dash"
                />
                <Typography variant="body1" className={classes.navTitle}>
                  Dashboard
                </Typography>
              </RouterLink>
            </Grid>

            <Grid className={classes.diableListItem}>
              {/* classes.activeNav we can for active and remove disableListItem */}

              <RouterLink
                exact
                to="/course"
                activeClassName={classes.activeNav}
              >
                <Route
                  path="/course"
                  children={({ match }) => (
                    <>
                      <img
                        src={
                          !match
                            ? "/assets/svg/goalGreyNav.svg"
                            : "/assets/svg/goalNav.svg"
                        }
                        width="33"
                        alt="goal"
                      />
                      <Typography variant="body1" className={classes.navTitle}>
                        Courses
                      </Typography>
                    </>
                  )}
                />
              </RouterLink>
            </Grid>
            {checkModuleAccess("goal") ? (
            <Grid className={classes.navItem}>
                <RouterLink
                  to="/goal-management"
                  activeClassName={classes.activeNav}
                  className={[classes.notActiveNav, classes.hoverImg, classes.goalImg].join(" ")}
                >
                  <Route
                    path="/goal-management"
                    children={({ match }) => (
                      <>
                        <img
                          src={
                            !match
                              ? "/assets/svg/goalGreyNav.svg"
                              : "/assets/svg/goalNav.svg"
                          }
                          width="24"
                          alt="goal"
                        />
                      </>
                    )}
                  />
                </RouterLink>
            </Grid>
             ) : null}

            <Grid className={classes.navItem}>
              <RouterLink
                exact
                to={`/mylibrary`}
                isActive={isActiveMyLibrary}
                activeClassName={classes.activeNav}
                className={[classes.notActiveNav,classes.hoverImg, classes.myLibrary].join(" ")}
              >
                <Route
                  path={`/mylibrary`}
                  children={({ match, location }) => {
                    return (
                      <>
                        <img
                          src={
                            isActiveMyLibrary(match, location)
                              ? "/assets/svg/myLibraryNav.svg"
                              : "/assets/svg/libraryGreyNav.svg"
                          }
                          width="24"
                          alt="library"
                        />
                      </>
                    );
                  }}
                />
              </RouterLink>
            </Grid>
            {checkModuleAccess("edp") ? (
            <Grid className={classes.navItem}>
                <RouterLink
                  exact
                  to="/reports"
                  activeClassName={classes.activeNav}
                  className={[classes.notActiveNav,classes.hoverImg, classes.reportImg].join(" ")}
                >
                  <Route
                    path="/reports"
                    children={({ match }) => (
                      <>
                        <img
                          src={
                            !match
                              ? "/assets/svg/greyReportNav.svg"
                              : "/assets/svg/blueReportNav.svg"
                          }
                          width="24"
                          alt="goal"
                        />
                      </>
                    )}
                  />
                </RouterLink>
            </Grid>
             ) : null}
             
              {checkModuleAccess("user") ? (

            <Grid className={classes.navItem}>
              {/* classes.activeNav we can for active and remove disableListItem . className={classes.diableListItem}*/}
                <RouterLink
                  exact
                  to="/userManagement"
                  activeClassName={classes.activeNav}
                  className={[classes.notActiveNav,classes.hoverImg, classes.userImg].join(" ")}
                >
                 <Route
                    path="/userManagement"
                    children={({ match }) => (
                      <>
                  <img src={!match ? "/assets/svg/userManagement/user-icon-grey.svg" : "/assets/svg/userManagement/user-icon.svg"} width="24" alt="user" />

                      </>
                    )}
                  />
                </RouterLink>
            </Grid>
               ) : null}
          </Grid>

          <Grid item alignItems="center">
            <IconButton
              classes={{
                root: notificationCount
                  ? classes.primaryNotificationColor
                  : classes.defaultNotificationColor,
              }}
              onMouseOver={this.handleHover.bind(this)}
              onMouseOut={this.handleHover.bind(this)}
              onClick={this.handleNotificationOpen.bind(this)}
              className={showTooltip && classes.notificationIcon}
            >
              <Badge badgeContent={notificationCount} color="secondary">
                <NotificationsIcon />
              </Badge>
              {showTooltip ? (
                <>
                  <CustomInfoIcon
                    isInfoIcon={false}
                    isCenterArrow={false}
                    isRightArrow={false}
                    details="Click to view notifications"
                    toolTipDirection="center"
                  />
                </>
              ) : (
                ""
              )}
            </IconButton>                     
          </Grid>
        </Grid>
      </AppBar>
    );
  }
}

const mapStateToProps = (state: any) => {
  let userData: any = state.loginData.userData;
  if (!userData.authenticatedUser) {
    userData.authenticatedUser = {
      fullname: "",
      profileImage: "",
      roles: [
        {
          role: "",
        },
      ],
    };
  }

  return {
    userData: userData,
    notificationList: _.get(state, "header.notification.list", []),
    notificationCount: _.get(state, "header.notification.count", 0),
  };
};

const isActiveMyLibrary = function(match: any, location: any) {
  if (match) {
    return true;
  } else {
    return location.pathname.indexOf("/content/preview/") !== -1;
  }
};

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      logout: userActionV2.logout,
      switchRole: userActionV2.switchRole,
      showMsgLogOut,
      getNotificationCount,
      getNotificationList,
      clearNotification,
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
  )(withRouter((withStyles(styles)(Header))))
);
